import api from "./api";
import axios from "axios";

class BilanciPrevisionaliManager {
    bilanciList(config?: any) {
        return api.get(`/bilanci_previsionali/`, config)
    }

    bilancio(bilancio_id: number | string, config?: any) {
        return api.get(`/bilanci_previsionali/${bilancio_id}`, config)
    }

    update(bilancio_id: number | string, data: any) {
        return api.put(`/bilanci_previsionali/${bilancio_id}`, data)
    }

    create(data: any) {
        return api.post(`/bilanci_previsionali/`, data)
    }

    detail(bilancio_id: number | string) {
        return api.get(`/bilanci_previsionali/${bilancio_id}`)
    }

    retrieve = this.bilancio
    list = this.bilanciList
    paginatedList = this.bilanciList

}

const bilanciPrevisionaliManager = new BilanciPrevisionaliManager()

export default bilanciPrevisionaliManager

